"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.camelObject = exports.camelArray = exports.snakeArray = exports.snakeObject = exports.toSnake = exports.toCamel = void 0;
const toCamel = (s) => {
    if (!s)
        return '';
    return s.replace(/([-_][a-z])/ig, ($1) => {
        return $1.toUpperCase()
            .replace('-', '')
            .replace('_', '');
    });
};
exports.toCamel = toCamel;
const camelArray = function (array) {
    if (!array) {
        return [];
    }
    let newArray = [];
    for (let i = 0; i < array.length; i++) {
        if (typeof array[i] === 'object' && array[i] !== null) {
            if (!Array.isArray(array[i])) {
                newArray[i] = camelObject(array[i]);
            }
            else {
                newArray[i] = camelArray(array[i]);
            }
        }
        else {
            newArray[i] = array[i];
        }
    }
    return newArray;
};
exports.camelArray = camelArray;
const camelObject = function (object) {
    let newObject = {};
    Object.keys(object).forEach(function (key) {
        let newKey = toCamel(key);
        if (typeof object[key] === 'object' && object[key] !== null) {
            if (!Array.isArray(object[key])) {
                newObject[newKey] = camelObject(object[key]);
            }
            else {
                newObject[newKey] = camelArray(object[key]);
            }
        }
        else {
            newObject[newKey] = object[key];
        }
    });
    return newObject;
};
exports.camelObject = camelObject;
const toSnake = (s) => {
    if (!s)
        return '';
    let res = s.replace(/\.?([A-Z]+)/g, function (x, y) {
        return "_" + y.toLowerCase();
    }).replace(/^_/, "");
    if (s.substr(0, 1) === '_') {
        res = '_' + res;
    }
    return res;
};
exports.toSnake = toSnake;
const snakeArray = function (array) {
    let newArray = [];
    for (let i = 0; i < array.length; i++) {
        if (typeof array[i] === 'object' && array[i] !== null) {
            if (!Array.isArray(array[i])) {
                newArray[i] = snakeObject(array[i]);
            }
            else {
                newArray[i] = snakeArray(array[i]);
            }
        }
        else {
            newArray[i] = array[i];
        }
    }
    return newArray;
};
exports.snakeArray = snakeArray;
const snakeObject = function (object) {
    let newObject = {};
    Object.keys(object).forEach(function (key) {
        let newKey = toSnake(key);
        if (typeof object[key] === 'object' && object[key] !== null) {
            if (!Array.isArray(object[key])) {
                newObject[newKey] = snakeObject(object[key]);
            }
            else {
                newObject[newKey] = snakeArray(object[key]);
            }
        }
        else {
            newObject[newKey] = object[key];
        }
    });
    return newObject;
};
exports.snakeObject = snakeObject;
//# sourceMappingURL=util.js.map